import React from "react";
import { Modal } from "@mui/material";

import Button from "../../../../../componentsv2/Button";
import { Input } from "../../../../../componentsv2/Input";

export default function ModalRegistrarEvolucao({
  open,
  modo = "registrar",
  descricao,
  data,
  hora,
  salvando,
  onClose,
  onDescricaoChange,
  onDataChange,
  onHoraChange,
  onRegistrar,
}) {
  const editando = modo === "editar";

  return (
    <Modal open={open} onClose={onClose}>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "min(92vw, 760px)",
          backgroundColor: "#FFFFFF",
          borderRadius: "14px",
          padding: "28px 24px",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.24)",
        }}
      >
        <h3 style={{ margin: "0 0 20px 0", color: "#101B43", fontSize: "30px" }}>
          {editando ? "Editar Evolução" : "Registrar Evolução"}
        </h3>

        <div style={{ marginBottom: "14px" }}>
          <Input
            fullWidth
            multiline
            minRows={5}
            maxRows={6}
            label="Evolução"
            variant="outlined"
            placeholder="Descreva como foi o procedimento..."
            value={descricao}
            onChange={event => onDescricaoChange(event.target.value)}
          />
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px", marginBottom: "22px" }}>
          <Input
            fullWidth
            type="date"
            label="Data *"
            variant="outlined"
            value={data}
            onChange={event => onDataChange(event.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <Input
            fullWidth
            type="time"
            label="Hora *"
            variant="outlined"
            value={hora}
            onChange={event => onHoraChange(event.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          <Button type="button" variant="outlined" color="gray" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            type="button"
            variant="contained"
            color="blue"
            onClick={onRegistrar}
            disabled={salvando}
          >
            {editando ? "Salvar" : "Registrar"}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

